<template>
  <div>
    <div class="columns is-multiple is-centered">
      <div class="column" v-for="(chart, index) in charts" :key="index">
        <div v-if="isChartEmpty(chart)" class="empty-pie">
          <div class="title">{{ $t(chart.options.title.text) }}</div>
          <div class="pie">
            <div class="text">{{ $t('pie_charts.no_info') }}</div>
          </div>
        </div>
        <VueApexCharts v-else type="pie" height="300" :options="chart.options" :series="chart.series" />
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { mapGetters } from 'vuex';

export default {
  name: 'PieCharsTeam',
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    /**
     * player's position id
     */
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getGamesPlayedByTeam: 'filterGeneral/getGamesPlayedByTeam',
    }),
    gamesPlayed() {
      return this.getGamesPlayedByTeam === 0 ? 1 : this.getGamesPlayedByTeam;
    },
    charts() {
      if (this.type != 1) {
        return [
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.team.successful_passes'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['1/4', '2/4', '3/4', '4/4'],
              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.successfulPasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.team.unsuccessful_passes'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: ['1/4', '2/4', '3/4', '4/4'],
              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.unsuccessfulPasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.team.balls_recovered'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.team.own_half'),
                this.$t('pie_charts.possession.team.opponents_half'),
              ],
              colors: ['#0060ff', '#00cae7'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.ballsRecovered,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.team.balls_lost'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.team.own_half'),
                this.$t('pie_charts.possession.team.opponents_half'),
              ],
              colors: ['#ef4a62', '#ffca4c'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.lostBalls,
          },
        ];
      } else {
        return [
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.goalkeeper.long_pass'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.goalkeeper.successful'),
                this.$t('pie_charts.possession.goalkeeper.unsuccessful'),
              ],
              colors: ['#4b47ae', '#0060ff', '#00cae7', '#9aeee1'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.longpasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.goalkeeper.short_pass'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.goalkeeper.successful'),
                this.$t('pie_charts.possession.goalkeeper.unsuccessful'),
              ],
              colors: ['#b91930', '#ef4a62', '#ffc81d', '#f3f464'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.shortpasses,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.goalkeeper.throw'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.goalkeeper.successful'),
                this.$t('pie_charts.possession.goalkeeper.unsuccessful'),
              ],
              colors: ['#0060ff', '#00cae7'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.handclearance,
          },
          {
            options: {
              dataLabels: {
                enabled: false,
              },
              chart: {
                height: 300,
                type: 'pie',
              },
              title: {
                text: this.$t('pie_charts.possession.goalkeeper.punt'),
                align: 'center',
                style: {
                  fontSize: '12px',
                },
              },
              labels: [
                this.$t('pie_charts.possession.goalkeeper.successful'),
                this.$t('pie_charts.possession.goalkeeper.unsuccessful'),
              ],
              colors: ['#ef4a62', '#ffca4c'],
              tooltip: {
                enabled: true,
                //eslint-disable-next-line no-unused-vars
                custom: function({ series, seriesIndex, dataPointIndex, w }) {
                  let total = 0;
                  for (let x of series) {
                    total += x;
                  }
                  let selected = series[seriesIndex];
                  return (
                    w.config.labels[seriesIndex] + ': ' + selected + ' (' + ((selected / total) * 100).toFixed(2) + '%)'
                  );
                },
              },
              legend: {
                position: 'bottom',
                fontSize: '11px',
                fontFamily: 'Avenir-Demi',
                itemMargin: {
                  horizontal: 7,
                  vertical: 5,
                },
                markers: {
                  width: 12,
                  height: 12,
                  strokeWidth: 0,
                  strokeColor: '#fff',
                  fillColors: undefined,
                  radius: 4,
                  customHTML: undefined,
                  onClick: undefined,
                  offsetX: 0,
                  offsetY: 0,
                },
              },
            },
            series: this.footclearance,
          },
        ];
      }
    },
    successfulPasses() {
      return [
        this.proccesedAverage(this.data[0].items[0].totalAccumulated),
        this.proccesedAverage(this.data[0].items[1].totalAccumulated),
        this.proccesedAverage(this.data[0].items[2].totalAccumulated),
        this.proccesedAverage(this.data[0].items[3].totalAccumulated),
      ];
    },
    unsuccessfulPasses() {
      return [
        this.proccesedAverage(this.data[2].items[0].totalAccumulated),
        this.proccesedAverage(this.data[2].items[1].totalAccumulated),
        this.proccesedAverage(this.data[2].items[2].totalAccumulated),
        this.proccesedAverage(this.data[2].items[3].totalAccumulated),
      ];
    },
    ballsRecovered() {
      return [
        this.proccesedAverage(this.data[3].items[0].totalAccumulated + this.data[4].items[0].totalAccumulated),
        this.proccesedAverage(this.data[3].items[1].totalAccumulated + this.data[4].items[1].totalAccumulated),
      ];
    },
    lostBalls() {
      return [
        this.proccesedAverage(this.data[5].items[0].totalAccumulated + this.data[6].items[0].totalAccumulated),
        this.proccesedAverage(this.data[5].items[1].totalAccumulated + this.data[6].items[1].totalAccumulated),
      ];
    },
    longpasses() {
      return [
        this.proccesedAverage(this.data[0].items[0].totalAccumulated),
        this.proccesedAverage(this.data[0].items[1].totalAccumulated),
      ];
    },
    shortpasses() {
      return [
        this.proccesedAverage(this.data[0].items[2].totalAccumulated),
        this.proccesedAverage(this.data[0].items[3].totalAccumulated),
      ];
    },
    handclearance() {
      return [
        this.proccesedAverage(this.data[1].items[0].totalAccumulated),
        this.proccesedAverage(this.data[1].items[1].totalAccumulated),
      ];
    },
    footclearance() {
      return [
        this.proccesedAverage(this.data[2].items[0].totalAccumulated),
        this.proccesedAverage(this.data[2].items[1].totalAccumulated),
      ];
    },
  },
  methods: {
    proccesedAverage(value) {
      return +(value / this.gamesPlayed).toFixed(2);
    },
    isChartEmpty(chartInfo) {
      const totalAccumulated = chartInfo.series.reduce((total, partial) => {
        return total + partial;
      }, 0);
      return totalAccumulated === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-pie {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;

  & .title {
    font-family: Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 900;
    padding-top: 0.3rem;
    margin-bottom: 0.7rem;
  }

  & .pie {
    width: 12em;
    height: 12em;
    border-radius: 50%;
    background-color: rgba(224, 231, 241, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    & > .text {
      font-family: Avenir-Medium;
      font-weight: 500;
      color: white;
      border-radius: 1.25em;
      padding: 0.5em 1em;
      background-color: #cad2de;
    }
  }

  @media screen and (max-width: 926px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
}
</style>
